import { render, staticRenderFns } from "./JSONEditor.vue?vue&type=template&id=0dcdafe8"
import script from "./JSONEditor.vue?vue&type=script&lang=ts"
export * from "./JSONEditor.vue?vue&type=script&lang=ts"
import style0 from "./JSONEditor.vue?vue&type=style&index=0&id=0dcdafe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports